import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: () =>
      import(/* webpackChunkName: "schedule" */ '../views/Schedule/Schedule.vue')
  },
  {
    path: '/schedule/pay/:eventId',
    name: 'Pay',
    component: () =>
      import(/* webpackChunkName: "schedule" */ '../views/Schedule/Pay.vue')
  },
  {
    path: '/schedule/edit/:eventId',
    name: 'Edit Tournament',
    component: () =>
      import(/* webpackChunkName: "schedule" */ '../views/Schedule/Edit.vue')
  },
  {
    path: '/documents/edit/:documentId',
    name: 'Add Document',
    component: () =>
      import(/* webpackChunkName: "document" */ '../views/Documents/Edit.vue')
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: () =>
      import(/* webpackChunkName: "calendar" */ '../views/Calendar/Calendar.vue')
  },
  {
    path: '/calendar/edit/:calendarEventId',
    name: 'Edit Calendar Event',
    component: () =>
      import(/* webpackChunkName: "calendar" */ '../views/Calendar/Edit.vue')
  },
  {
    path: '/document/:documentId',
    name: 'Document',
    component: () => import(/* webpackChunkName: "doc-view" */ '../views/Documents/View.vue')
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import(/* webpackChunkName: "faq" */ '../views/FAQ/FAQ.vue')
  },
  {
    path: '/faq/edit/:faqId',
    name: 'Edit FAQ',
    component: () =>
      import(/* webpackChunkName: "faqedit" */ '../views/FAQ/Edit.vue')
  },
  {
    path: '/account/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Account/Login.vue')
  },
  {
    path: '/account/logout',
    name: 'Logout',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Account/Logout.vue')
  },
  {
    path: '/account/register',
    name: 'Register',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Account/Register.vue')
  },
  {
    path: '/account/reset',
    name: 'Reset',
    component: () =>
      import(/* webpackChunkName: "reset" */ '../views/Account/ResetPassword.vue')
  },
  {
    path: '/account/forgot',
    name: 'ForgotUsername',
    component: () =>
      import(/* webpackChunkName: "forgotusername" */ '../views/Account/ForgotUsername.vue')
  },
  {
    path: '/account/passwordReset/:tk',
    name: 'PasswordReset',
    component: () =>
      import(/* webpackChunkName: "password reset" */ '../views/Account/PasswordReset.vue')
  },
  {
    path: '/account/home',
    name: 'AccountHome',
    component: () =>
      import(/* webpackChunkName: "accounthome reset" */ '../views/Account/Home.vue')
  },
  {
    path: '/account/profile',
    name: 'AccountProfile',
    component: () =>
      import(/* webpackChunkName: "accountprofile" */ '../views/Account/Profile.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '../views/News/News.vue')
  },
  {
    path: '/news/edit/:newsId',
    name: 'Edit New Article',
    component: () =>
      import(/* webpackChunkName: "news edit" */ '../views/News/Edit.vue')
  },  
  {
    path: '/money',
    name: 'Money',
    component: () =>
      import(/* webpackChunkName: "money list" */ '../views/Money/Money.vue')
  },
  {
    path: '/money/manage/:eventId',
    name: 'Manage',
    component: () =>
      import(/* webpackChunkName: "money list" */ '../views/Money/Manage.vue')
  },
  {
    path: '/money/edit/:eventId/:memberWinningId',
    name: 'Edit Winnings',
    component: () =>
      import(/* webpackChunkName: "money list" */ '../views/Money/Edit.vue')
  },
  {
    path: '/results',
    name: 'Results',
    component: () =>
      import(/* webpackChunkName: "Results" */ '../views/Results/Results.vue')
  },
  {
    path: '/association',
    name: 'Association',
    component: () =>
      import(/* webpackChunkName: "Association" */ '../views/Association/Association.vue')
  },
  {
    path: '/links',
    name: 'Links',
    component: () =>
      import(/* webpackChunkName: "Links" */ '../views/Links/Links.vue')
  },
  {
    path: '/links/edit/:linkId',
    name: 'LinksEdit',
    component: () =>
      import(/* webpackChunkName: "LinksEdit" */ '../views/Links/Edit.vue')
  },
  {
    path: '/association/board/:boardId',
    name: 'Association',
    component: () =>
      import(/* webpackChunkName: "Board Edit" */ '../views/Association/BoardEdit.vue')
  },
  {
    path: '/association/edit',
    name: 'AssociationEdit',
    component: () =>
      import(/* webpackChunkName: "Association" */ '../views/Admin/Association.vue')
  },
  {
    path: '/admin/members',
    name: 'Members',
    component: () =>
      import(/* webpackChunkName: "Members" */ '../views/Admin/Members.vue')
  },
  {
    path: '/admin/member/edit/:memberId',
    name: 'MemberEdit',
    component: () =>
      import(/* webpackChunkName: "Members" */ '../views/Admin/MemberEdit.vue')
  },
  {
    path: '/admin/users',
    name: 'Users',
    component: () =>
      import(/* webpackChunkName: "Users" */ '../views/Admin/Users.vue')
  },
  {
    path: '/admin/users/:search',
    name: 'Users',
    component: () =>
      import(/* webpackChunkName: "Users" */ '../views/Admin/Users.vue')
  },
  {
    path: '/admin/user/edit/:id',
    name: 'UserEdit',
    component: () =>
      import(/* webpackChunkName: "Users" */ '../views/Admin/UserEdit.vue')
  },
  {
    path: '/admin/roles/',
    name: 'User Roles',
    component: () =>
      import(/* webpackChunkName: "User Roless" */ '../views/Admin/UserRoles.vue')
  },
  {
    path: '/admin/payments/',
    name: 'Payments',
    component: () =>
      import(/* webpackChunkName: "User Roless" */ '../views/Admin/Payments.vue')
  },
  {
    path: '/unauth',
    name: 'Unauthorized',
    component: () =>
      import(/* webpackChunkName: "Unauth" */ '../views/Unauthorized.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
